// src/components/InvalidCredentialsModal.jsx
import React from "react";
import { Modal } from "react-bootstrap";
import Button from "../../../components/atoms/button/Button";

const InvalidCredentialsModal = ({ show, onHide }) => {
  return (
    // prevent ESC and backdrop click, remove header close button so only OK closes it
    <Modal show={show} centered backdrop="static" keyboard={false}>
      <Modal.Header>
        <Modal.Title className="fw-bold">Alert</Modal.Title>
      </Modal.Header>
      <Modal.Body>Invalid credentials</Modal.Body>
      <Modal.Footer>
         <Button variant="active" onClick={onHide}>
          OK
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InvalidCredentialsModal;
